import { ROLE_WILDCARD_PUBLIC, UnespCoreMenuItem } from '@unesp/core'

export const menuStpg: UnespCoreMenuItem[] = [
  // STPG
  {
    displayName: 'Documentos',
    iconName: 'folder_open',
    roles: ['STPG'],
    order: 1,
    children: [
      {
        displayName: 'Cadastro / Emissão',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 1,
        route: `redirect-legado/STPG_DOCUMENTOS_CADASTRO_EMISSAO/ROLE_UNESP.SISPG_STPG`,
      },
      {
        displayName: 'Lista Emitidos',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 2,
        route: `redirect-legado/STPG_DOCUMENTOS_LISTA_EMITIDOS/ROLE_UNESP.SISPG_STPG`,
      },
      {
        displayName: 'Pesquisar Solicitações',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 3,
        route: `redirect-legado/STPG_DOCUMENTOS_PESQUISAR_SOLICITACOES/ROLE_UNESP.SISPG_STPG`,
      },
      {
        displayName: 'Exame Geral de Qualificação',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 4,
        children: [
          {
            displayName: 'Cartaz de Divulgação',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 1,
            route: `redirect-legado/STPG_DOCUMENTOS_QUALIFICACAO_CARTAZ/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Convite para Comissão Examinadora - CE',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 2,
            route: `redirect-legado/STPG_DOCUMENTOS_QUALIFICACAO_CONVITE_CE/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Convite para Comissão Examinadora - SE',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 3,
            route: `redirect-legado/STPG_DOCUMENTOS_QUALIFICACAO_CONVITE_SE/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Etiqueta',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 4,
            route: `redirect-legado/STPG_DOCUMENTOS_QUALIFICACAO_ETIQUETA/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Atestado de Participação em Comissão Examinadora',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 5,
            route: `redirect-legado/STPG_DOCUMENTOS_QUALIFICACAO_ATESTADO/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Parecer do Examinador',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 6,
            route: `redirect-legado/STPG_DOCUMENTOS_QUALIFICACAO_PARECER/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Certificado de Aprovação de Exame de Qualificação',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 7,
            route: `redirect-legado/STPG_DOCUMENTOS_QUALIFICACAO_CERTIFICADO/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Atestado de Aprovação de Exame de Qualificação',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 8,
            route: `redirect-legado/STPG_DOCUMENTOS_QUALIFICACAO_ATESTADO_APROVACAO/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Ata da Reunião',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 9,
            route: `redirect-legado/STPG_DOCUMENTOS_QUALIFICACAO_ATA/ROLE_UNESP.SISPG_STPG`,
          },
        ],
      },
      {
        displayName: 'Defesa de Dissertação/Teste',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 5,
        children: [
          {
            displayName: 'Cartaz de Divulgação',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 1,
            route: `redirect-legado/STPG_DOCUMENTOS_DEFESA_CARTAZ/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Convite para Comissão Examinadora - CE',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 2,
            route: `redirect-legado/STPG_DOCUMENTOS_DEFESA_CONVITE_CE/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Convite para Comissão Examinadora - SE',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 3,
            route: `redirect-legado/STPG_DOCUMENTOS_DEFESA_CONVITE_SE/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Etiqueta',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 4,
            route: `redirect-legado/STPG_DOCUMENTOS_DEFESA_ETIQUETA/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Atestado de Participação em Comissão Examinadora',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 5,
            route: `redirect-legado/STPG_DOCUMENTOS_DEFESA_ATESTADO/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Parecer do Examinador',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 6,
            route: `redirect-legado/STPG_DOCUMENTOS_DEFESA_PARECER/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Certificado de Aprovação de Defesa sem Título',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 7,
            route: `redirect-legado/STPG_DOCUMENTOS_DEFESA_CERTIFICADO_ST/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Certificado de Aprovação de Defesa com Título',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 8,
            route: `redirect-legado/STPG_DOCUMENTOS_DEFESA_CT/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Atestado de Aprovação de Defesa',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 9,
            route: `redirect-legado/STPG_DOCUMENTOS_DEFESA_ATESTADO_APROVACAO/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Ata da Reunião sem Título',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 10,
            route: `redirect-legado/STPG_DOCUMENTOS_DEFESA_ATA_ST/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Ata da Reunião',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 11,
            route: `redirect-legado/STPG_DOCUMENTOS_DEFESA_ATA/ROLE_UNESP.SISPG_STPG`,
          },
        ],
      },
      {
        displayName: 'Atestados',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 6,
        children: [
          {
            displayName: 'Matrícula em Curso',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 1,
            route: `redirect-legado/STPG_DOCUMENTOS_ATESTADOS_MATRICULA_REGULAR/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Matrícula em Curso - Inglês',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 2,
            route: `redirect-legado/STPG_DOCUMENTOS_ATESTADOS_MATRICULA_INGLES/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Matrícula em Disciplina - Regular',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 3,
            route: `redirect-legado/STPG_DOCUMENTOS_ATESTADOS_MATRICULA_DISCIPLINA_REGULAR/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Disciplinas Cursadas e Atividades',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 4,
            route: `redirect-legado/STPG_DOCUMENTOS_ATESTADOS_DISCIPLINAS_CURSADAS_REGULAR/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Matrícula em Disciplina - Especial',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 5,
            route: `redirect-legado/STPG_DOCUMENTOS_ATESTADOS_MATRICULA_DISCIPLINA_ESPECIAL/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Disciplinas Cursadas - Especial',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 6,
            route: `redirect-legado/STPG_DOCUMENTOS_ATESTADOS_DISCIPLINAS_CURSADAS_ESPECIAL/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Bolsa/Auxílio',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 7,
            route: `redirect-legado/STPG_DOCUMENTOS_ATESTADOS_BOLSISTAS/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Credenciamento - Ativo',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 8,
            route: `redirect-legado/STPG_DOCUMENTOS_ATESTADOS_CREDENCIAMENTO_ATIVO/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Credenciamento - Inativo',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 9,
            route: `redirect-legado/STPG_DOCUMENTOS_ATESTADOS_CREDENCIAMENTO_INATIVO/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Orientações',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 10,
            route: `redirect-legado/STPG_DOCUMENTOS_ATESTADOS_ORIENTACOES/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Disciplinas Ministradas',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 11,
            route: `redirect-legado/STPG_DOCUMENTOS_ATESTADOS_DISCIPLINAS_MINISTRADAS/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Participações em Comissões Examinadoras - Titular',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 12,
            route: `redirect-legado/STPG_DOCUMENTOS_ATESTADOS_PARTICIPACAO_TITULAR/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Participações em Comissões Examinadoras - Suplente',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 13,
            route: `redirect-legado/STPG_DOCUMENTOS_ATESTADOS_PARTICIPACAO_SUPLENTE/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Participaçõse no Conselho do Programa',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 14,
            route: `redirect-legado/STPG_DOCUMENTOS_ATESTADOS_PARTICIPACAO_CONSELHO/ROLE_UNESP.SISPG_STPG`,
          },
        ],
      },
      {
        displayName: 'Ofícios',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 7,
        children: [
          {
            displayName: 'Homologação de Trabalho',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 1,
            route: `redirect-legado/STPG_DOCUMENTOS_OFICIOS_HOMOLOGACAO_TRABALHO/ROLE_UNESP.SISPG_STPG`,
          },
        ],
      },
      {
        displayName: 'Discentes',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 8,
        children: [
          {
            displayName: 'Histórico em Andamento',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 1,
            route: `redirect-legado/STPG_DOCUMENTOS_DISCENTES_HISTORICO_ANDAMENTO/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Certificado de Conclusão',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 2,
            route: `redirect-legado/STPG_DOCUMENTOS_DISCENTES_CERTIFICADO_CONCLUSAO/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Certificado de Conclusão - Inglês',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 3,
            route: `redirect-legado/STPG_DOCUMENTOS_DISCENTES_CERTIFICADO_CONCLUSAO_INGLES/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Histórico Escolar',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 4,
            route: `redirect-legado/STPG_DOCUMENTOS_DISCENTES_HISTORICO/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Histórico Escolar - Inglês',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 5,
            route: `redirect-legado/STPG_DOCUMENTOS_DISCENTES_HISTORICO_INGLES/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Declaração de Cotutela',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 6,
            route: `redirect-legado/STPG_DOCUMENTOS_DISCENTES_COTUTELA/ROLE_UNESP.SISPG_STPG`,
          },
        ],
      },
    ],
  },
  {
    displayName: 'Relatórios',
    iconName: 'inventory',
    roles: ['STPG'],
    order: 2,
    children: [
      {
        displayName: 'Programas',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 1,
        children: [
          {
            displayName: 'Coordenações',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 1,
            route: `redirect-legado/STPG_RELATORIOS_PROGRAMA_COORDENACOES/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Disciplinas',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 1,
            children: [
              {
                displayName: 'Estrutura Curricular',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 1,
                route: `redirect-legado/STPG_RELATORIOS_PROGRAMA_DISCIPLINAS_ESTRUTURA/ROLE_UNESP.SISPG_STPG`,
              },
              {
                displayName: 'Plano de Ensino',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 2,
                route: `redirect-legado/STPG_RELATORIOS_PROGRAMA_DISCIPLINAS_PLANO/ROLE_UNESP.SISPG_STPG`,
              },
              {
                displayName: 'Ministradas/Modelo 1',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 3,
                route: `redirect-legado/STPG_RELATORIOS_PROGRAMA_DISCIPLINAS_MINISTRADAS_M1/ROLE_UNESP.SISPG_STPG`,
              },
              {
                displayName: 'Ministradas/Modelo 2',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 4,
                route: `redirect-legado/STPG_RELATORIOS_PROGRAMA_DISCIPLINAS_MINISTRADAS_M2/ROLE_UNESP.SISPG_STPG`,
              },
            ],
          },
        ],
      },
      {
        displayName: 'Discentes',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 2,
        children: [
          {
            displayName: 'Todos',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 1,
            route: `redirect-legado/STPG_RELATORIOS_DISCENTES_TODOS/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Estrangeiros',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 2,
            route: `redirect-legado/STPG_RELATORIOS_DISCENTES_ESTRANGEIROS/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Por Programa',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 3,
            route: `redirect-legado/STPG_RELATORIOS_DISCENTES_POR_PROGRAMA/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Por Turma',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 4,
            route: `redirect-legado/STPG_RELATORIOS_DISCENTES_POR_TURMA/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Por Região',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 5,
            route: `redirect-legado/STPG_RELATORIOS_DISCENTES_POR_REGIAO/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Matrículas',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 6,
            children: [
              {
                displayName: 'Requeridas',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 1,
                route: `redirect-legado/STPG_RELATORIOS_DISCENTES_MATRICULAS_REQUERIDAS/ROLE_UNESP.SISPG_STPG`,
              },
              {
                displayName: 'Processadas',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 2,
                route: `redirect-legado/STPG_RELATORIOS_DISCENTES_MATRICULAS_PROCESSADAS/ROLE_UNESP.SISPG_STPG`,
              },
            ],
          },
          {
            displayName: 'Lista de Presença',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 7,
            route: `redirect-legado/STPG_RELATORIOS_DISCENTES_LISTA_PRESENCA/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Bolsistas',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 8,
            route: `redirect-legado/STPG_RELATORIOS_DISCENTES_BOLSISTAS/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Estágio docência',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 9,
            route: `redirect-legado/STPG_RELATORIOS_DISCENTES_PAADES/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Projeto',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 10,
            route: `redirect-legado/STPG_RELATORIOS_DISCENTES_PROJETO/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Prorrogação',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 11,
            route: `redirect-legado/STPG_RELATORIOS_DISCENTES_PRORROGACAO/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Prazos',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 12,
            children: [
              {
                displayName: 'Exigidos',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 1,
                route: `redirect-legado/STPG_RELATORIOS_DISCENTES_PRAZOS_EXIGIDOS/ROLE_UNESP.SISPG_STPG`,
              },
              {
                displayName: 'Cumpridos',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 2,
                route: `redirect-legado/STPG_RELATORIOS_DISCENTES_PRAZOS_CUMPRIDOS/ROLE_UNESP.SISPG_STPG`,
              },
            ],
          },
          {
            displayName: 'Suspensos',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 13,
            route: `redirect-legado/STPG_RELATORIOS_DISCENTES_SUSPENSOS/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Desligados',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 14,
            route: `redirect-legado/STPG_RELATORIOS_DISCENTES_DESLIGADOS/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Especiais',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 15,
            route: `redirect-legado/STPG_RELATORIOS_DISCENTES_ESPECIAIS/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Mobilidades',
            iconName: 'travel_explore',
            roles: ['STPG'],
            order: 16,
            children: [
              {
                displayName: 'Outgoing',
                iconName: 'move_up',
                roles: ['STPG'],
                order: 1,
                route: 'stpg/mobilidade/outgoing',
              },
              {
                displayName: 'Incoming',
                iconName: 'move_down',
                roles: ['STPG'],
                order: 2,
                route: 'stpg/mobilidade/incoming',
              },
            ],
          },
        ],
      },
      {
        displayName: 'Docentes',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 3,
        children: [
          {
            displayName: 'Todos',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 1,
            route: `redirect-legado/STPG_RELATORIOS_DOCENTES_TODOS/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Dados Cadastrais',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 2,
            route: `redirect-legado/STPG_RELATORIOS_DOCENTES_DADOS_CADASTRAIS/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Lista de Presença',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 3,
            route: `redirect-legado/STPG_RELATORIOS_DOCENTES_LISTA_PRESENCA/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Orientações',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 4,
            route: `redirect-legado/STPG_RELATORIOS_DOCENTES_ORIENTACOES/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Linha de Pesquisa',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 5,
            route: `redirect-legado/STPG_RELATORIOS_DOCENTES_LINHA_PESQUISA/ROLE_UNESP.SISPG_STPG`,
          },
        ],
      },
      {
        displayName: 'Turmas',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 4,
        children: [
          {
            displayName: 'Por Programa',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 1,
            route: `redirect-legado/STPG_RELATORIOS_TURMAS_POR_PROGRAMA/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Por Docente',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 2,
            route: `redirect-legado/STPG_RELATORIOS_TURMAS_POR_DOCENTE/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Não Ministradas',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 3,
            route: `redirect-legado/STPG_RELATORIOS_TURMAS_NAO_MINISTRADAS/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Não Consolidadas',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 4,
            route: `redirect-legado/STPG_RELATORIOS_TURMAS_NAO_CONSOLIDADAS/ROLE_UNESP.SISPG_STPG`,
          },
        ],
      },
      {
        displayName: 'Processos Seletivos',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 5,
        children: [
          {
            displayName: 'Aluno Regular',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 1,
            children: [
              {
                displayName: 'Todos',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 1,
                route: `redirect-legado/STPG_RELATORIOS_PROCESSO_SELETIVO_REGULAR_TODOS/ROLE_UNESP.SISPG_STPG`,
              },
              {
                displayName: 'Por Nome',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 2,
                route: `redirect-legado/STPG_RELATORIOS_PROCESSO_SELETIVO_REGULAR_POR_NOME/ROLE_UNESP.SISPG_STPG`,
              },
              {
                displayName: 'Orientador/Idioma',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 3,
                route: `redirect-legado/STPG_RELATORIOS_PROCESSO_SELETIVO_REGULAR_ORIENTADOR/ROLE_UNESP.SISPG_STPG`,
              },
              {
                displayName: 'Necessidades Especiais',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 4,
                route: `redirect-legado/STPG_RELATORIOS_PROCESSO_SELETIVO_REGULAR_NECESSIDADES_ESPECIAIS/ROLE_UNESP.SISPG_STPG`,
              },
              {
                displayName: 'Reserva de Vagas',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 5,
                route: `redirect-legado/STPG_RELATORIOS_PROCESSO_SELETIVO_RESERVA_VAGAS/ROLE_UNESP.SISPG_STPG`,
              },
              {
                displayName: 'Etiqueta',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 6,
                route: `redirect-legado/STPG_RELATORIOS_PROCESSO_SELETIVO_REGULAR_ETIQUETA/ROLE_UNESP.SISPG_STPG`,
              },
              {
                displayName: 'Lista de Presença',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 7,
                route: `redirect-legado/STPG_RELATORIOS_PROCESSO_SELETIVO_REGULAR_LISTA_PRESENCA/ROLE_UNESP.SISPG_STPG`,
              },
            ],
          },
          {
            displayName: 'Aluno Especial',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 2,
            children: [
              {
                displayName: 'Todos',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 1,
                route: `redirect-legado/STPG_RELATORIOS_PROCESSO_SELETIVO_ESPECIAL_TODOS/ROLE_UNESP.SISPG_STPG`,
              },
              {
                displayName: 'Candidatos/Disciplinas',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 2,
                route: `redirect-legado/STPG_RELATORIOS_PROCESSO_SELETIVO_ESPECIAL_CANDIDATO_DISCIPLINA/ROLE_UNESP.SISPG_STPG`,
              },
              {
                displayName: 'Disciplinas/Candidatos',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 3,
                route: `redirect-legado/STPG_RELATORIOS_PROCESSO_SELETIVO_ESPECIAL_DISCIPLINA_CANDIDATO/ROLE_UNESP.SISPG_STPG`,
              },
              {
                displayName: 'Necessidades Especiais',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 4,
                route: `redirect-legado/STPG_RELATORIOS_PROCESSO_SELETIVO_ESPECIAL_NECESSIDADES_ESPECIAIS/ROLE_UNESP.SISPG_STPG`,
              },
              {
                displayName: 'Etiqueta',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 5,
                route: `redirect-legado/STPG_RELATORIOS_PROCESSO_SELETIVO_ESPECIAL_ETIQUETA/ROLE_UNESP.SISPG_STPG`,
              },
              {
                displayName: 'Lista de Presença',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 6,
                route: `redirect-legado/STPG_RELATORIOS_PROCESSO_SELETIVO_ESPECIAL_LISTA_PRESENCA/ROLE_UNESP.SISPG_STPG`,
              },
              {
                displayName: 'Disciplinas/Matriculados',
                iconName: 'navigate_next',
                roles: ['STPG'],
                order: 7,
                route: `redirect-legado/STPG_RELATORIOS_PROCESSO_SELETIVO_ESPECIAL_DISCIPLINAS_MATRICULADOS/ROLE_UNESP.SISPG_STPG`,
              },
            ],
          },
        ],
      },
      {
        displayName: 'Comissão Examinadora',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 6,
        children: [
          {
            displayName: 'Qualificações',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 1,
            route: `redirect-legado/STPG_RELATORIOS_COMISSAO_EXAMINADORA_QUALIFICACOES/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Defesas',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 2,
            route: `redirect-legado/STPG_RELATORIOS_COMISSAO_EXAMINADORA_DEFESAS/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Defesas não Homologadas',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 3,
            route: `redirect-legado/STPG_RELATORIOS_COMISSAO_EXAMINADORA_DEFESAS_HOMOLOGADAS/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Tempo Médio',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 4,
            route: `redirect-legado/STPG_RELATORIOS_COMISSAO_EXAMINADORA_TEMPO_MEDIO/ROLE_UNESP.SISPG_STPG`,
          },
        ],
      },
    ],
  },
  {
    displayName: 'Dados Estatísticos',
    iconName: 'bar_chart',
    roles: ['STPG'],
    order: 3,
    children: [
      {
        displayName: 'Estrangeiros',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 1,
        children: [
          {
            displayName: 'Por Programa',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 1,
            route: `redirect-legado/STPG_DADOS_ESTRANGEIROS_POR_PROGRAMA/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Por Área de Concentração',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 2,
            route: `redirect-legado/STPG_DADOS_ESTRANGEIROS_POR_CONCENTRACAO/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Por País - Todos',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 3,
            route: `redirect-legado/STPG_DADOS_ESTRANGEIROS_POR_PAIS/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Por País - Ingressantes',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 4,
            route: `redirect-legado/STPG_DADOS_ESTRANGEIROS_POR_PAIS_INGRESSANTE/ROLE_UNESP.SISPG_STPG`,
          },
          {
            displayName: 'Estrangeiro/Brasileiro',
            iconName: 'navigate_next',
            roles: ['STPG'],
            order: 5,
            route: `redirect-legado/STPG_DADOS_ESTRANGEIROS_BRASILEIRO/ROLE_UNESP.SISPG_STPG`,
          },
        ],
      },
      {
        displayName: 'Pós em Números',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 2,
        route: `redirect-legado/STPG_DADOS_POS_NUMEROS/ROLE_UNESP.SISPG_STPG`,
      },
      {
        displayName: 'Matriculados',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 3,
        route: `redirect-legado/STPG_DADOS_MATRICULADOS/ROLE_UNESP.SISPG_STPG`,
      },
      {
        displayName: 'Formados',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 4,
        route: `redirect-legado/STPG_DADOS_FORMADOS/ROLE_UNESP.SISPG_STPG`,
      },
      {
        displayName: 'Desligados/Suspensos',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 5,
        route: `redirect-legado/STPG_DADOS_DESLIGADOS/ROLE_UNESP.SISPG_STPG`,
      },
      {
        displayName: 'Necessidades Especiais',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 6,
        route: `redirect-legado/STPG_DADOS_NECESSIDADES_ESPECIAIS/ROLE_UNESP.SISPG_STPG`,
      },
      {
        displayName: 'Alunos Regulares',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 7,
        route: `redirect-legado/STPG_DADOS_ALUNOS_REGULARES/ROLE_UNESP.SISPG_STPG`,
      },
      {
        displayName: 'Alunos Bolsistas',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 8,
        route: `redirect-legado/STPG_DADOS_BOLSISTAS/ROLE_UNESP.SISPG_STPG`,
      },
      {
        displayName: 'Quadro Resumo',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 9,
        route: `redirect-legado/STPG_DADOS_RESUMO/ROLE_UNESP.SISPG_STPG`,
      },
    ],
  },
  {
    displayName: 'Programas',
    iconName: 'book',
    roles: ['STPG'],
    order: 4,
    route: `redirect-legado/STPG_PROGRAMAS/ROLE_UNESP.SISPG_STPG`,
  },
  {
    displayName: 'Linhas de Pesquisa',
    iconName: 'plagiarism',
    roles: ['STPG'],
    order: 5,
    route: `redirect-legado/STPG_LINHA_PESQUISA/ROLE_UNESP.SISPG_STPG`,
  },
  {
    displayName: 'Projetos',
    iconName: 'receipt_long',
    roles: ['STPG'],
    order: 6,
    route: `redirect-legado/STPG_PROJETO/ROLE_UNESP.SISPG_STPG`,
  },
  {
    displayName: 'Docentes',
    iconName: 'attribution',
    roles: ['STPG'],
    order: 7,
    children: [
      {
        displayName: 'Dados Cadastrais',
        iconName: 'description',
        roles: ['STPG'],
        order: 1,
        route: '/stpg/docente/dados-cadastrais',
      },
      {
        displayName: 'Desefetivar Turmas',
        iconName: 'group_off',
        roles: ['STPG'],
        order: 2,
        route: `/stpg/docente/desefetivar-turmas`,
      },
    ],
  },
  {
    displayName: 'Discentes',
    iconName: 'account_circle',
    roles: ['STPG'],
    order: 8,
    children: [
      {
        displayName: 'Regular',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 1,
        children: [
          {
            displayName: 'Aproveitamento de Crédito',
            iconName: 'change_circle',
            roles: ['STPG'],
            order: 1,
            route: '/stpg/discente-regular/aproveitamento-creditos',
          },
          {
            displayName: 'Atividades Complementares',
            iconName: 'file_copy',
            roles: ['STPG'],
            order: 2,
            route: '/stpg/discente-regular/atividade-complementar',
          },
          {
            displayName: 'Bolsas/Auxílios',
            iconName: 'work',
            roles: ['STPG'],
            order: 3,
            route: '/stpg/discente-regular/bolsa',
          },
          {
            displayName: 'Central de Acessos',
            iconName: 'fingerprint',
            roles: ['STPG'],
            order: 4,
            route: '/stpg/discente-regular/central-acessos',
          },
          {
            displayName: 'Dados Cadastrais',
            iconName: 'description',
            roles: ['STPG'],
            order: 5,
            route: '/stpg/discente-regular/dados-cadastrais',
          },
          {
            displayName: 'Documentação',
            iconName: 'attach_file',
            roles: ['STPG'],
            order: 6,
            route: '/stpg/discente-regular/documentacao',
          },
          {
            displayName: 'Horário de Aulas',
            iconName: 'schedule',
            roles: ['STPG'],
            order: 7,
            route: '/stpg/discente-regular/horario-aulas',
          },
          {
            displayName: 'Mobilidades',
            iconName: 'travel_explore',
            roles: ['STPG'],
            order: 8,
            route: '/stpg/discente-regular/mobilidade',
          },
          {
            displayName: 'Ocorrências',
            iconName: 'event_available',
            roles: ['STPG'],
            order: 9,
            route: '/stpg/discente-regular/ocorrencia',
          },
          {
            displayName: 'Prazos',
            iconName: 'alarm',
            roles: ['STPG'],
            order: 10,
            route: '/stpg/discente-regular/prazos',
          },
          {
            displayName: 'Prazos Cumpridos',
            iconName: 'check_circle',
            roles: ['STPG'],
            order: 11,
            route: '/stpg/discente-regular/prazos-cumpridos',
          },
          {
            displayName: 'Proficiência em Línguas',
            iconName: 'language',
            roles: ['STPG'],
            order: 12,
            route: '/stpg/discente-regular/proficiencia',
          },
          {
            displayName: 'Situação Acadêmica',
            iconName: 'info',
            roles: ['STPG'],
            order: 13,
            route: '/stpg/discente-regular/situacao-academica',
          },
        ],
      },
      {
        displayName: 'Especial',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 2,
        children: [
          {
            displayName: 'Central de Acessos',
            iconName: 'fingerprint',
            roles: ['STPG'],
            order: 1,
            route: '/stpg/discente-especial/central-acessos',
          },
          {
            displayName: 'Dados Cadastrais',
            iconName: 'description',
            roles: ['STPG'],
            order: 2,
            route: '/stpg/discente-especial/dados-cadastrais',
          },
          {
            displayName: 'Documentação',
            iconName: 'attach_file',
            roles: ['STPG'],
            order: 3,
            route: '/stpg/discente-especial/documentacao',
          },
          {
            displayName: 'Horário de Aulas',
            iconName: 'schedule',
            roles: ['STPG'],
            order: 4,
            route: '/stpg/discente-especial/horario-aulas',
          },
          {
            displayName: 'Situação Acadêmica',
            iconName: 'info',
            roles: ['STPG'],
            order: 5,
            route: '/stpg/discente-especial/situacao-academica',
          },
        ],
      },
    ],
  },
  {
    displayName: 'Participante Externo',
    iconName: 'supervised_user_circle',
    roles: ['STPG'],
    order: 9,
    children: [
      {
        displayName: 'Dados Cadastrais',
        iconName: 'description',
        roles: ['STPG'],
        order: 1,
        route: '/stpg/participante-externo/dados-cadastrais',
      },
      {
        displayName: 'Central de Acessos',
        iconName: 'fingerprint',
        roles: ['STPG'],
        order: 2,
        route: '/stpg/participante-externo/central-acessos',
      },
    ],
  },
  {
    displayName: 'Instituição Externa',
    iconName: 'public',
    roles: ['STPG'],
    order: 10,
    route: `redirect-legado/STPG_INSTITUICAO_EXTERNA/ROLE_UNESP.SISPG_STPG`,
  },
  {
    displayName: 'Calendário',
    iconName: 'calendar_month',
    roles: ['STPG'],
    order: 11,
    children: [
      {
        displayName: 'Calendário Regular',
        iconName: 'calendar_month',
        roles: ['STPG'],
        order: 1,
        route: '/stpg/calendario',
      },
      {
        displayName: 'Calendário Portfólio',
        iconName: 'calendar_month',
        roles: ['STPG'],
        order: 2,
        route: '/stpg/calendario-portfolio',
      },
    ],
  },
  {
    displayName: 'Processo Seletivo',
    iconName: 'filter_alt',
    roles: ['STPG'],
    order: 12,
    children: [
      {
        displayName: 'Conta Bancária',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 1,
        route: `redirect-legado/STPG_PROCESSO_SELETIVO_CONTA_BANCARIA/ROLE_UNESP.SISPG_STPG`,
      },
      {
        displayName: 'Documentação',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 2,
        route: `redirect-legado/STPG_PROCESSO_SELETIVO_DOCUMENTACAO/ROLE_UNESP.SISPG_STPG`,
      },
      {
        displayName: 'Aluno Regular',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 3,
        route: `redirect-legado/STPG_PROCESSO_SELETIVO_ALUNO_REGULAR/ROLE_UNESP.SISPG_STPG`,
      },
      {
        displayName: 'Aluno Especial',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 4,
        route: `redirect-legado/STPG_PROCESSO_SELETIVO_ALUNO_ESPECIAL/ROLE_UNESP.SISPG_STPG`,
      },
      {
        displayName: 'Inscrição Regular',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 5,
        route: `processo-seletivo/aluno-regular`,
      },
      {
        displayName: 'Inscrição Especial',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 6,
        route: `processo-seletivo/aluno-especial`,
      },
      {
        displayName: 'Candidatos Inscritos',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 7,
        route: `redirect-legado/STPG_PROCESSO_SELETIVO_CANDIDATOS_INSCRITOS/ROLE_UNESP.SISPG_STPG`,
      },
      {
        displayName: 'Links',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 8,
        route: `redirect-legado/STPG_PROCESSO_SELETIVO_LINK/ROLE_UNESP.SISPG_STPG`,
      },
    ],
  },
  {
    displayName: 'Rol de Disciplinas',
    iconName: 'format_list_bulleted',
    roles: ['STPG'],
    order: 13,
    children: [
      {
        displayName: 'Oferecimento de Turmas',
        iconName: 'groups',
        roles: ['STPG'],
        order: 1,
        route: 'stpg/rol-disciplinas/oferecimento-turma',
      },
      {
        displayName: 'Oferecimento de Turmas Portfólio',
        iconName: 'groups',
        roles: ['STPG'],
        order: 1,
        route: 'stpg/rol-disciplinas/oferecimento-turma-portfolio',
      },
      {
        displayName: 'Matrícula',
        iconName: 'edit_calendar',
        roles: ['STPG'],
        order: 2,
        route: 'stpg/rol-disciplinas/matricula',
      },
      {
        displayName: 'Processamento Matrícula',
        iconName: 'query_stats',
        roles: ['STPG'],
        order: 3,
        route: 'stpg/rol-disciplinas/processamento-matricula',
      },
    ],
  },
  {
    displayName: 'Comissão Examinadora',
    iconName: 'groups',
    roles: ['STPG'],
    order: 14,
    route: `redirect-legado/STPG_COMISSAO_EXAMINADORA/ROLE_UNESP.SISPG_STPG`,
  },
  {
    displayName: 'Estagiários',
    iconName: 'person_add',
    roles: ['STPG'],
    order: 16,
    route: `/stpg/estagiario`,
  },
  {
    displayName: 'Mensagens',
    iconName: 'mail',
    roles: ['STPG'],
    order: 17,
    addBottomDivider: true,
    children: [
      {
        displayName: 'Recebidas',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 1,
        route: `redirect-legado/STPG_MENSAGENS_RECEBIDAS/ROLE_UNESP.SISPG_STPG`,
      },
      {
        displayName: 'Enviadas',
        iconName: 'navigate_next',
        roles: ['STPG'],
        order: 2,
        route: `redirect-legado/STPG_MENSAGENS_ENVIADAS/ROLE_UNESP.SISPG_STPG`,
      },
    ],
  },
  // PUBLICO
  {
    displayName: 'Processo seletivo',
    iconName: 'grading',
    roles: [ROLE_WILDCARD_PUBLIC],
    order: 997,
    children: [
      {
        displayName: 'Aluno regular',
        iconName: 'edit_note',
        roles: [ROLE_WILDCARD_PUBLIC],
        order: 1,
        route: 'processo-seletivo/aluno-regular',
      },
      {
        displayName: 'Aluno especial',
        iconName: 'edit_note',
        roles: [ROLE_WILDCARD_PUBLIC],
        order: 2,
        route: 'processo-seletivo/aluno-especial',
      },
    ],
  },
  {
    displayName: 'Autenticidade de documento',
    iconName: 'qr_code_scanner',
    roles: [ROLE_WILDCARD_PUBLIC],
    route: 'autenticidade-documento',
    order: 998,
  },
  // COMUN
  {
    displayName: 'Ajuda/Suporte',
    iconName: 'contact_support',
    roles: [ROLE_WILDCARD_PUBLIC],
    route: 'ajuda/suporte',
    order: 999,
  },
  {
    displayName: 'Voltar ao portal',
    iconName: 'home',
    roles: [ROLE_WILDCARD_PUBLIC],
    route: 'voltar-portal',
    order: 1000,
  },
]
